const viewMoreElement = document.querySelector('.js-btn-load-more');

if (viewMoreElement) {
  let isLoading = false;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && !isLoading && !viewMoreElement.hasAttribute('disabled')) {
        isLoading = true;
        viewMoreElement.click();

        // Ждём пока загрузка завершится (кнопка станет enabled снова)
        const checkLoaded = setInterval(() => {
          if (!viewMoreElement.hasAttribute('disabled')) {
            isLoading = false;
            clearInterval(checkLoaded);
          }
        }, 200);
      }
    });
  }, {
    rootMargin: '0px 0px 200px 0px', // Срабатывать за 200px до видимости кнопки
    threshold: 0.1 // Минимум 10% кнопки должно быть видно
  });

  // Задержка перед началом наблюдения, чтобы не сработать при первом рендере
  setTimeout(() => {
    observer.observe(viewMoreElement);
  }, 1000);
}
